<template>
    <div class="p-6 bg-gray-100 min-h-screen flex flex-col items-center justify-center pb-40">
      <div class="max-w-md w-full">
        <!-- Input para token -->
        <div class="mb-4">
          <label for="token" class="block text-gray-700 font-bold mb-2">Ingrese el Token del Premio:</label>
          <input
            id="token"
            v-model="token"
            type="text"
            placeholder="Ejemplo: ABC123"
            class="w-full px-4 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
  
        <!-- Botones -->
        <div class="flex gap-4 mb-6">
          <button
            @click="buscarPremio"
            class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 w-full">
            Buscar
          </button>
          <button
            @click="limpiarPantalla"
            class="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 w-full">
            Limpiar Pantalla
          </button>
        </div>
  
        <!-- Contenido dinámico -->
        <div v-if="premio" class="bg-white p-6 rounded shadow">
          <h2 class="text-xl font-bold mb-4">Información del Premio</h2>
          <p><strong>Token:</strong> {{ premio.token_premio || 'N/A' }}</p>
          <p><strong>Premio:</strong> {{ premio.premio || 'N/A' }}</p>
          <p><strong>Activo:</strong> {{ premio.activo === '1' ? 'Sí' : 'No' }}</p>
          <p v-if="premio.utilizado"><strong>Utilizado:</strong> {{ premio.utilizado }}</p>
          <div v-if="premio.activo === '1'" class="mt-4">
            <button
              @click="desactivarPremio"
              class="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600">
              Desactivar Premio
            </button>
          </div>
        </div>
  
        <!-- Imagen por defecto -->
        <div v-else class="flex justify-center items-center">
          <img src="@/assets/logohp.png" alt="HP Logo" class="w-64 h-auto" />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    data() {
      return {
        token: "",
        premio: null,
      };
    },
    methods: {
      async buscarPremio() {
        if (!this.token) {
          alert("Por favor, ingrese un token válido.");
          return;
        }
  
        try {
          const { data } = await axios.post("/api/premios-sorteados/consultar", {
            token_premio: this.token ,
          });
          this.premio = data.data;
        } catch (error) {
          console.error("Error al buscar el premio:", error);
          alert("No se encontró el premio o ocurrió un error.");
          this.premio = null;
        }
      },
      async desactivarPremio() {
        if (!this.premio || this.premio.activo !== "1") {
          alert("El premio ya está desactivado o no es válido.");
          return;
        }
  
        try {
          await axios.post("/api/premios-sorteados/desactivar", {
            token_premio: this.premio.token_premio,
          });
          alert("Premio desactivado exitosamente.");
          this.buscarPremio(); // Refresca la información del premio
        } catch (error) {
          console.error("Error al desactivar el premio:", error);
          alert("Ocurrió un error al desactivar el premio.");
        }
      },
      limpiarPantalla() {
        this.token = "";
        this.premio = null;
      },
    },
  };
  </script>
  
  <style scoped>
  /* Puedes añadir estilos personalizados si es necesario */
  img {
    border-radius: 10px;
  }
  </style>
  